import './libs/modernizr.js';
import './libs/bootstrap';


// JS class helper
var body = document.querySelector('body');
body.classList.add('js');

// To top body class helper
window.onscroll = function(e) {
    if (window.pageYOffset > 500) {
        body.classList.add('show-to-top');
    } else {
        body.classList.remove('show-to-top');
    }
};

// Touch body class helper
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    body.classList.add('touch');
}

require('./modules/headroom')
require('./modules/lazy-load')
require('./modules/slider')
require('./modules/gridderjs')
require('./modules/gridder')
require('./modules/map')
require('./modules/ajax-form-handler')
require('./modules/aos')
// require('./modules/ajax-posts')
require('./modules/testimonial')
require('./modules/mobile')
require('./modules/custom')


function bTar() {

//alert("browse");


}


jQuery(document).ready(function($) {

console.log("FRDBG");

    $('#supply-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#supplybtntxt').toggle();
        });

    $('#wasser-areas').click(function(){
            $('#tariff_calculator_form').toggleClass('visible');
            $('#supply-areas-map').toggle();
            $('#tarifbtntxt').toggle();
            $('#wasserbtntxt').toggle();
        });

    $("#select-tarif").click(function(){
console.log('TOGGLE BUTTON');
            $('#tarif-result').toggle();
            getTariff();
console.log('getTariff() OK');
        });

    $(".ctype").click(function(){
//console.log(this);
	    if (this.className.indexOf('priv') > 0) {
//alert('priv');
		$('#ctype_priv').addClass('selected');
		$('#ctype_busi').removeClass('selected');
		$('#customer_type').val('PRIVATE');
            } else {
                $('#ctype_busi').addClass('selected');
                $('#ctype_priv').removeClass('selected');
		$('#customer_type').val('BUSINESS');
            }
        });


    $(".personinhouse").click(function(){
        
        var pb = [];
        pb[1] = "0";
        pb[2] = "40%";
        pb[3] = "70%";
        pb[4] = "100%";


        var pa = [];
        pa[1] = "0";
        pa[2] = "30%";
        pa[3] = "60%";
        pa[4] = "90%";

        var personnum = this.dataset.val;
        var data_val = this.dataset.value;
        $('.personinhouse').removeClass('selected');
        for (let index = 1; index <= personnum; index++) {
            $(".progress"+index).addClass('selected');
        }

	var factor = (document.getElementById("media_type").value === "POWER") ? 1800 : 150;


	document.getElementById("verbrauch").value = personnum * factor;

        $(".profileprogress_baractive").css("width",pb[personnum]);
        $(".profileprogress_active").css("left",pa[personnum]);

        $("#personinhouse_value").val(data_val);
    });

});

let showTariffs = false;

let tariffs = [];

function getTariff() {


  console.log(document.getElementById("tarif-result").style.display);
  //console.log(document.getElementById("tarif-result").style);


  if (!showTariffs) {
//  if (document.getElementById("tarif-result").style.display != 'block') {

// postleitzahl, verbrauch, personinhouse_value
//if (tariffs.length < 1) {




var postleitzahl = document.getElementById("postleitzahl").value;

var ctype = document.getElementById("ctype_busi").classList.contains("selected") ? "BUSINESS" : "PRIVATE";


	showTariffs = true;
	var errorMsg = '';

    var data = {
      action: "tariff_call",
      my_input: "some_value tariff"
    };
    jQuery.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: "action=" + data.action + "&my_input=" + data.my_input + "&media_type=" + document.getElementById("media_type").value + "&postleitzahl=" + document.getElementById("postleitzahl").value + "&verbrauch=" + document.getElementById("verbrauch").value + "&customer_type=" + ctype,
      success: function success(response) {


	errorMsg = '';

        console.log('Response:', response);
        var jsonObject = JSON.parse(response);
        tariffs = jsonObject.tariffs;

if ("undefined" != typeof tariffs && tariffs.length > 0) {
//if ("undefined" != tariffs && tariffs.length > 0) {
//if (tariffs && tariffs.length) {


        console.log('Object value:', tariffs);

	let contEl = document.getElementById("tarif-tiles");
	let html = "";
	contEl.innerHTML = html;

	var tL = tariffs.length;

        console.log("Tarife: " + tariffs.length);

//      if (tariffs.length < 1)
//              return;


        for (var i=0; i<tariffs.length; i++)
//if (i < 1)
	{

                console.log(i);

        // add tariff html
                // in  div tariff_calculator_form
//                html = html + '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus ' + i + '</h3><div class="tarif-price">monatlich ca. <span class="tarif-pricetext" style="color:#E94E1B">44,46</span> ct/kWh</div><div class="tarif-content"><ul><li>Arbeitspreis ab 30,84 ct*</li><li>Grundpreis ab 4,73 €*</li><li>Kündigungsfrist 2 Wochen</li></ul><p><button class="tariff-btn">Traif buchen</button><span style="font-size:30px;" onclick="bTar();">></span></p></div></div></div>';

// '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus</h3><div class="tarif-price">monatli$

// '<div id="tarif-result" style="display: block;"><div class="tarif-item"><span class="recommended">Empfehlung</span><h3 class="tarif-title">Plus</h3><div class="tarif-price">monatli$';


        var disp = (i < 1) ? 'block' : 'none';

        var arbeitspreis = tariffs[i].TariffParts[0].TimeSlices[0].ConsumptionSlices[0].Price.Netto.toFixed(2).replace(".", ",");
        var grundpreis = tariffs[i].TariffParts[2].Name.indexOf('PERIODICAL_BASE_PRICE') == 0 ? tariffs[i].TariffParts[2].TimeSlices[0].ConsumptionSlices[0].Price.Netto.toFixed(2) : "kein";
        var kuendigungsfrist = tariffs[i].CancellationPeriodDisplayValue;
        var tarifname = tariffs[i].TariffName.split("-")[1].split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
	var recommended = (i < 1) ? '<span class="recommended">Empfehlung</span>' : '';


          html = html + '<div id="tarif-result-' + i + '" style="display: '+disp+';max-width:800px;"><div class="tarif-item">' + recommended + '<h3 class="tarif-title" style="min-height:100px;width:330px;">' + tarifname + '</h3>';
	  html = html + '<div class="tarif-price-block" style="">';
	  html = html + '<img id="tl'+i+'" src="/wp-content/themes/strom/public/images/green-arrow.svg" onclick="if (0=='+i+') return false;this.parentElement.parentElement.parentElement.style.display=\'none\';document.getElementById(\'tarif-result-\'+(parseInt(this.id.substr(2,1))-1)).style.display=\'block\';" style="height:70px;width:40px;transform: scaleX(-1);margin-top:40px;cursor:pointer;">';
	  
	  html = html + '<div class="tarif-price">monatlich ca. <span class="tarif-pricetext" style="color:#E94E1B">44,46</span> ct/kWh</div>';
	  html = html + '<img id="tr'+i+'" onclick="if ('+tL+'-1=='+i+') return false;this.parentElement.parentElement.parentElement.style.display=\'none\';document.getElementById(\'tarif-result-\'+(parseInt(this.id.substr(2,1))+1)).style.display=\'block\';" src="/wp-content/themes/strom/public/images/green-arrow.svg" style="height:70px;width:40px;margin-top:40px;cursor:pointer;">';
	  html = html + '</div>';
	  html = html + '<div class="tarif-content"><ul><li>Arbeitspreis ab ' + arbeitspreis + ' ct*</li><li>Grundpreis ab '+ grundpreis +' €*</li><li>Kündigungsfrist ' + kuendigungsfrist + '</li></ul><p><button class="tariff-btn">Tarif buchen</button>';
//          html = html + '<span style="font-size:30px;cursor:pointer;" id="tf'+i+'" onclick="if (0=='+i+') return false;this.parentElement.parentElement.parentElement.parentElement.style.display=\'none\';document.getElementById(\'tarif-result-\'+(parseInt(this.id.substr(2,1))-1)).style.display=\'block\';"><</span>&nbsp;&nbsp;';
//          html = html + '<span style="font-size:30px;cursor:pointer;" id="tf'+i+'" onclick="if ('+tL+'-1=='+i+') return false;this.parentElement.parentElement.parentElement.parentElement.style.display=\'none\';document.getElementById(\'tarif-result-\'+(parseInt(this.id.substr(2,1))+1)).style.display=\'block\';">></span>';
	  html = html + '<br><br>';
          html = html + '</p></div></div></div>';

        }

        contEl.innerHTML = html;

//        jQuery('#tarif-result').toggle();

        errorMsg = '';

//} // tarrifs length - already loaded

  } else {

        errorMsg = 'Die Postleitzahl ist ungültig.';

	jQuery('#tarif-result').toggle();

showTariffs = false;

  }

//alert(errorMsg);

  document.getElementById('errorMsg').innerHTML = errorMsg;

      } // function success
    }); // end ajax


  } else {

//	jQuery('#tarif-result').toggle();

showTariffs = false;

  }

//alert("OK");



}







function getTariff1(url) {

console.log(document.getElementById("tarif-result").style.display);
//console.log(document.getElementById("tarif-result").style);

	if (document.getElementById("tarif-result").style.display != 'block') {


		var data = {
			action: "tariff_call",
			my_input: "some_value tariff"
		};


		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: "action=" + data.action + "&my_input=" + data.my_input,
			success: function(response) {
				console.log('Response:', response);
				const jsonObject = JSON.parse(response);
				console.log('Object value:', jsonObject.systemOperator);

				jQuery('#tarif-result').toggle();
			}
		});


	} else

	        jQuery('#tarif-result').toggle();

}

console.log("======");

function setCustomerType(typeStr) {
//alert("OK");
/*
        if (!typeStr) {
                document.getElementById('ctype_busi').class = '';
                document.getElementById('ctype_priv').class = 'selected';
                document.getElementById('customer_type').value = 'PRIVATE';
        } else {
                document.getElementById('ctype_busi').class = 'selected';
                document.getElementById('ctype_priv').class = '';
                document.getElementById('customer_type').value = 'BUSINESS';
        }
//      document.getElementById('customer_type').value = typeStr;
//id="ctype_busi" class="selected" onclick="setCustomerType('BUSINESS');">Gewerb
*/
}


jQuery(document).ready(function($) {
//alert('sugg1');
  $('#street').autocomplete({
    source: function(request, response) {
      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'autocomplete_street',
          term: request.term
        },
        success: function(data) {
          response(data);
        }
      });
    },
    minLength: 2
  });

  $('#housenumber').autocomplete({
    source: function(request, response) {
      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'autocomplete_housenumber',
          street: $('#street').val(),
          term: request.term
        },
        success: function(data) {
          response(data);
        }
      });
    },
    minLength: 1
  });
});

// ok
